const monthLabels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const dayLabels = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];

const translate = string => string;
const doubleSymbolsNumber = number => number > 9 ? number : `0${number}`;

class SuperDate extends Date {
    getReadableMonth (lang) {
        const monthIndex = this.getMonth();
        const monthLabel = translate(monthLabels[monthIndex], lang);

        return monthLabel;
    }

    getReadableDay (lang) {
        const dayIndex = this.getDay();
        const dayLabel = translate(dayLabels[dayIndex], lang);

        return dayLabel;
    }

    getReadableDate (lang) {
        const day = this.getDate();
        const month = this.getReadableMonth(lang).slice(0, 3);
        const year = this.getFullYear();

        return `${day} ${month} ${year}`;
    }

    getFullDate () {
        const year = this.getFullYear();
        let month = this.getMonth() + 1;
        let day = this.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }

        return `${year}${month}${day}`;
    }

    /*
     * Date formats rely on the PHP format specification: https://www.php.net/manual/en/datetime.format.php
     * 1. Year formats (options: 'Y', 'y').
     * 2. Month formats (options: 'F', 'M', 'm', 'n').
     * 3. Day formats (options: 'D', 'd', 'l', 'j').
     * 3. Time formats (options: 'D', 'd', 'l', 'j').
     */
    toFormat (format, lang = 'en') {
        let formattedDate = format;

        /* [1] */
        if (format.includes('Y')) {formattedDate = formattedDate.replace(/(Y)/g, this.getFullYear());}
        if (format.includes('y')) {formattedDate = formattedDate.replace(/(y)/g, this.getFullYear() - 2000);}

        /* [2] */
        if (format.includes('F')) {formattedDate = formattedDate.replace(/(F)/g, this.getReadableMonth(lang));}
        if (format.includes('M')) {formattedDate = formattedDate.replace(/(M)/g, this.getReadableMonth(lang).slice(0, 3));}
        if (format.includes('m')) {formattedDate = formattedDate.replace(/(m)/g, doubleSymbolsNumber(this.getMonth() + 1));}
        if (format.includes('n')) {formattedDate = formattedDate.replace(/(n)/g, this.getMonth() + 1);}

        /* [3] */
        if (format.includes('D')) {formattedDate = formattedDate.replace(/(D)/g, this.getReadableDay().slice(0, 3));}
        if (format.includes('d')) {formattedDate = formattedDate.replace(/(d)/g, doubleSymbolsNumber(this.getDate()));}
        if (format.includes('l')) {formattedDate = formattedDate.replace(/(l)/g, this.getReadableDay());}
        if (format.includes('j')) {formattedDate = formattedDate.replace(/(j)/g, this.getDate());}

        /* [4] */
        if (format.includes('H')) {formattedDate = formattedDate.replace(/(H)/g, doubleSymbolsNumber(this.getHours()));}
        if (format.includes('i')) {formattedDate = formattedDate.replace(/(i)/g, doubleSymbolsNumber(this.getMinutes()));}
        if (format.includes('s')) {formattedDate = formattedDate.replace(/(s)/g, doubleSymbolsNumber(this.getSeconds()));}

        return formattedDate;
    }

    setTime (...args) {
        return new SuperDate(this.setHours(...args));
    }

    addMinute (increment = 1) {
        return new SuperDate(this.setMinutes(this.getMinutes() + increment));
    }

    addHour (increment = 1) {
        return new SuperDate(this.setHours(this.getHours() + increment));
    }

    addDate (increment = 1) {
        return new SuperDate(this.setDate(this.getDate() + increment));
    }

    addMonth (increment = 1) {
        return new SuperDate(this.setMonth(this.getMonth() + increment));
    }

    addYear (increment = 1) {
        return new SuperDate(this.setYear(this.getFullYear() + increment));
    }
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default SuperDate;
